import { LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";

import { VmgLogo } from "@/components";
import { useAuthentication } from "@/hooks";
import { useUserStore } from "@/stores";
import { Spinner } from "@/ui";
import { Breadcrumbs } from "@/ui/common/Breadcrumbs";

export const Header = () => {
  const { useLogout } = useAuthentication();
  const { mutate: logout, isPending } = useLogout();
  const { user } = useUserStore();
  const location = useLocation();

  let pages = [
    { name: "Home", href: "/home" },
    { name: "New intake", href: "/new-intake" },
  ];

  if (location.pathname === "/cases") {
    pages = [
      { name: "Home", href: "/home" },
      { name: "Cases", href: "/cases" },
    ];
  }

  return (
    <header>
      <div className="flex items-center justify-between px-16">
        <a href="/">
          <VmgLogo className="size-16 text-primary-950" />
        </a>
        <div className="flex items-center gap-4 text-sm text-neutral-500">
          <h3 className="font-semibold">{user?.name}</h3>
          {isPending ? (
            <Spinner />
          ) : (
            <LogOut onClick={() => logout()} className="text-primary-950" />
          )}
        </div>
      </div>
      <div className="bg-primary-50 px-16 py-3">
        <Breadcrumbs pages={pages} />
      </div>
    </header>
  );
};
